import { Directive, Input, HostListener } from '@angular/core';
import { Store, Action } from '@ngrx/store';

@Directive({
  selector: '[plrClickAction]'
})
export class ClickActionDirective {
  @Input() plrClickAction: Action;

  constructor(private store: Store<any>) { }

  @HostListener('click')
  onClick() {
    this.store.dispatch(this.plrClickAction);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/directives/click-action.directive.ts